module.exports = __webpack_public_path__ + "static/img/logo.bbcc2040.png";